import {
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  UPLOADING,
  SET_UPLOAD_PROGRESS,
  OPEN_SNACKBAR,
  SET_NO_AUTH_REDIRECT_FROM_URL
} from "../types";

const initialState = {
  loading: false,
  uploading: false,
  uploadingTitle: "",
  errorMessage: "",
  uploadProgress: 0,
  snackbarMassage: "",
  snackbarTimestamp: 0,
  noAuthRedirectFromUrl: "",
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SET_ERRORS:
      return {
        ...state,
        loading: false,
        errorMessage: payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        errorMessage: ""
      };
    case LOADING_UI:
      return {
        ...state,
        loading: payload
      };
    case UPLOADING:
      return {
        ...state,
        uploading: payload.status,
        uploadingTitle: payload.title
      };
    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: payload.progress,
        uploadNumFiles: payload.numFiles,
        uploadBytesTransferred: payload.bytesTransferred,
        uploadSize: payload.uploadSize,
        uploadEstimatedTimeLeft: payload.estimatedTimeLeft
      };
    case OPEN_SNACKBAR:
      return {
        ...state,
        snackbarMassage: payload.message,
        snackbarTimestamp: payload.timestamp
      };
    case SET_NO_AUTH_REDIRECT_FROM_URL:
      return {
        ...state,
        noAuthRedirectFromUrl: payload
      };
    default:
      return state;
  }
}
